<h4 data-force-focus="back">{{ 'tariff.selectionCard.priceDetailsTitle' | translate }}</h4>

@for (item of filteredItems(); track item.name) {
  <mwe-tariff-selection-card-collapse-item [item]="item" (collapseToggleClicked)="onCollapseToggleClicked()" />
}
